import React from 'react';
import SecurityHero from "../components/security/SecurityHero";
import ComplianceBadges from "../components/security/ComplianceBadges";
import SecurityFeatures from "../components/security/SecurityFeatures";
import EncryptionDiagram from "../components/security/EncryptionDiagram";
import BestPractices from "../components/security/BestPractices";
import IncidentResponse from "../components/security/IncidentResponse";

const SecurityPage = () => {
    return (
        <div className="min-h-screen bg-gray-50 dark:bg-slate-950 dark:text-slate-100 pt-16">
            <SecurityHero />
            <ComplianceBadges />
            <SecurityFeatures />
            <EncryptionDiagram />
            <BestPractices />
            <IncidentResponse />
        </div>
    );
};

export default SecurityPage;